module.exports = __webpack_public_path__ + "static/img/time-line-red-ar.64bcf33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/time-line-red-ar.png
// module id = 1239
// module chunks = 4